import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs'
import { PageMenu } from '../PageMenu/PageMenu'
import {
  SkeletonLoader,
  SKELETON_LOADER_VARIANT_ONWHITE
} from '../SkeletonLoader/SkeletonLoader'

import './PageHeader.scss'

export const PageHeader = ({
  title,
  breadcrumbsItems,
  menuItems,
  ControlsComponent,
  loading,
  className
}) => {
  const style = {}
  if (ControlsComponent) {
    style.overflow = 'unset'
  }

  return (
    <div className={classnames('b-page-header', className)} style={style}>
      <div className='b-page-header__wrapper'>
        <h1 className='b-page-header__title'>
          {loading ? (
            <SkeletonLoader
              width='400px'
              height='32px'
              variant={SKELETON_LOADER_VARIANT_ONWHITE}
            />
          ) : (
            title
          )}
        </h1>
        {ControlsComponent && (
          <div className='b-page-header__controls'>
            <ControlsComponent />
          </div>
        )}
        <Breadcrumbs items={breadcrumbsItems} />

        {menuItems && menuItems.length && <PageMenu items={menuItems} />}
      </div>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  breadcrumbsItems: PropTypes.array,
  ControlsComponent: PropTypes.any,
  menuItems: PropTypes.array,
  loading: PropTypes.bool,
  className: PropTypes.string
}
